const EmptyList = ({ permissions, ...props }) => {
  return null;
};

export default EmptyList;